import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useEntitlementList = ({ type, branchId, search }) => {
  const filter = {
    filter: {
      branchId: branchId,
      searchTerm: search,
    },
  };
  // const filter = {
  //   filter: {
  //     branchId: { branchFilter },
  //     searchTerm: { search },
  //   },
  // };
  return useQuery({
    queryKey: ["entitlementStaff", filter],
    queryFn: async () =>
      callApi({
        path: "entitlementstaff",
        command: type,
        data: JSON.stringify({ list: filter }),
      }),
    // placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};

// "{\"list\":{\"filter\":{\"branchId\":\"B001|B002\",\"searchTerm\":\"\"}}}"

// "list": {
//         "filter": {
//             "branchId": "B001|B002",
//             "searchTerm": null
//         },
//         "staff": [
//             {
//                 "staffid": "STA142784",
//                 "branchid": "B001",
//                 "name": "Creation Test1",
//                 "gender": "M",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "93939",
//                 "branchname": "Branch 1 Scotland",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "       12",
//                 "itemsCount": "23",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA122505",
//                 "branchid": "B002",
//                 "name": "Dave Piggleston",
//                 "gender": "O",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "0014566678",
//                 "branchname": "Branch 2 England",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "       15",
//                 "itemsCount": "25",
//                 "disablePostpone": "true",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA142794",
//                 "branchid": "B002",
//                 "name": "Dave Three",
//                 "gender": "M",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "9999",
//                 "branchname": "Branch 2 England",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "       14",
//                 "itemsCount": "25",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA142793",
//                 "branchid": "B001",
//                 "name": "Dave Two",
//                 "gender": "M",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "8888",
//                 "branchname": "Branch 1 Scotland",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "       13",
//                 "itemsCount": "24",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA122506",
//                 "branchid": "B001",
//                 "name": "George Pig",
//                 "gender": "M",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "001258",
//                 "branchname": "Branch 1 Scotland",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "       13",
//                 "itemsCount": "24",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA142757",
//                 "branchid": "B002",
//                 "name": "Peter Gibbons",
//                 "gender": "M",
//                 "uniform": "WARDROBE00762",
//                 "yourid": "BLUED123",
//                 "branchname": "Branch 2 England",
//                 "wardrobename": "Brook Taverner - Shirt & Blouse Collection",
//                 "productsCount": "       35",
//                 "itemsCount": "175",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             },
//             {
//                 "staffid": "STA122507",
//                 "branchid": "B001",
//                 "name": "Tom Drew",
//                 "gender": "M",
//                 "uniform": "WARDROBE00025",
//                 "yourid": "00147",
//                 "branchname": "Branch 1 Scotland",
//                 "wardrobename": "Standard Wardrobe",
//                 "productsCount": "        8",
//                 "itemsCount": "15",
//                 "disablePostpone": "false",
//                 "postponeDaysCnt": null
//             }
//         ]
//     }
